// // File Location: src/pages/admin/UserManagement.jsx

// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import {
//   Users,
//   Search,
//   Filter,
//   MoreVertical,
//   Eye,
//   Ban,
//   Unlock,
//   UserCheck,
//   UserX,
//   Building2,
//   Stethoscope,
//   CreditCard,
//   FileText,
//   TrendingUp,
//   Calendar,
//   Mail,
//   Phone,
//   Shield,
//   AlertTriangle,
//   CheckCircle,
//   Clock,
//   Download,
//   RefreshCw,
//   Plus,
//   Settings,
//   Activity,
//   UserPlus,
//   X
// } from 'lucide-react';
// import { 
//   getAllUsers, 
//   blockUser, 
//   unblockUser, 
//   getUserStats 
// } from '../../services/userService';
// import { useAuth } from '../../context/AuthContext';

// const UserManagement = () => {
//   const navigate = useNavigate();
//   const { userData } = useAuth();
  
//   const [users, setUsers] = useState([]);
//   const [filteredUsers, setFilteredUsers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [actionLoading, setActionLoading] = useState({});
//   const [searchTerm, setSearchTerm] = useState('');
//   const [selectedRole, setSelectedRole] = useState('all');
//   const [selectedStatus, setSelectedStatus] = useState('all');
//   const [showFilters, setShowFilters] = useState(false);
//   const [stats, setStats] = useState({});
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [showActionModal, setShowActionModal] = useState(false);
//   const [actionType, setActionType] = useState('');
//   const [actionReason, setActionReason] = useState('');

//   // User roles configuration
//   const userRoles = [
//     { 
//       value: 'all', 
//       label: 'All Users', 
//       icon: Users, 
//       color: 'text-gray-600',
//       bgColor: 'bg-gray-100' 
//     },
//     { 
//       value: 'LeadGenerator', 
//       label: 'Lead Generators', 
//       icon: TrendingUp, 
//       color: 'text-teal-600',
//       bgColor: 'bg-teal-100' 
//     },
//     { 
//       value: 'Hospital', 
//       label: 'Hospitals', 
//       icon: Building2, 
//       color: 'text-blue-600',
//       bgColor: 'bg-blue-100' 
//     },
//     { 
//       value: 'Doctor', 
//       label: 'Doctors', 
//       icon: Stethoscope, 
//       color: 'text-green-600',
//       bgColor: 'bg-green-100' 
//     },
//     { 
//       value: 'FinancialTeam', 
//       label: 'Financial Team', 
//       icon: CreditCard, 
//       color: 'text-purple-600',
//       bgColor: 'bg-purple-100' 
//     },
//     { 
//       value: 'PolicyWriter', 
//       label: 'Policy Writers', 
//       icon: FileText, 
//       color: 'text-orange-600',
//       bgColor: 'bg-orange-100' 
//     }
//   ];

//   useEffect(() => {
//     loadUsers();
//     loadStats();
//   }, []);

//   useEffect(() => {
//     filterUsers();
//   }, [users, searchTerm, selectedRole, selectedStatus]);

//   const loadUsers = async () => {
//     setLoading(true);
//     try {
//       const result = await getAllUsers();
//       if (result.success) {
//         setUsers(result.users);
//       } else {
//         console.error('Error loading users:', result.error);
//       }
//     } catch (error) {
//       console.error('Error loading users:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const loadStats = async () => {
//     try {
//       const result = await getUserStats();
//       if (result.success) {
//         setStats(result.stats);
//       }
//     } catch (error) {
//       console.error('Error loading stats:', error);
//     }
//   };

//   const filterUsers = () => {
//     let filtered = [...users];

//     // Filter by search term
//     if (searchTerm) {
//       filtered = filtered.filter(user => 
//         user.profile?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         user.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         user.entityName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         user.hospitalName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         user.profile?.phone?.includes(searchTerm)
//       );
//     }

//     // Filter by role
//     if (selectedRole !== 'all') {
//       filtered = filtered.filter(user => user.role === selectedRole);
//     }

//     // Filter by status
//     if (selectedStatus !== 'all') {
//       if (selectedStatus === 'active') {
//         filtered = filtered.filter(user => user.isActive && !user.isBlocked);
//       } else if (selectedStatus === 'blocked') {
//         filtered = filtered.filter(user => user.isBlocked);
//       } else if (selectedStatus === 'inactive') {
//         filtered = filtered.filter(user => !user.isActive);
//       }
//     }

//     setFilteredUsers(filtered);
//   };

//   const handleUserAction = async () => {
//     if (!selectedUser || !actionType) return;

//     const isBlocking = actionType === 'block';
//     if (isBlocking && !actionReason.trim()) return;

//     setActionLoading(prev => ({ ...prev, [selectedUser.uid]: true }));
    
//     try {
//       const result = isBlocking 
//         ? await blockUser(selectedUser.uid, userData.uid, actionReason)
//         : await unblockUser(selectedUser.uid, userData.uid);

//       if (result.success) {
//         // Update local state
//         setUsers(prev => prev.map(user => 
//           user.uid === selectedUser.uid 
//             ? { 
//                 ...user, 
//                 isBlocked: isBlocking,
//                 blockedBy: isBlocking ? userData.uid : null,
//                 blockedAt: isBlocking ? new Date() : null,
//                 blockReason: isBlocking ? actionReason : null,
//                 unblockedAt: isBlocking ? null : new Date()
//               }
//             : user
//         ));
        
//         setShowActionModal(false);
//         setSelectedUser(null);
//         setActionReason('');
//         alert(`User ${isBlocking ? 'blocked' : 'unblocked'} successfully!`);
//       } else {
//         alert(`Error ${isBlocking ? 'blocking' : 'unblocking'} user: ` + result.error);
//       }
//     } catch (error) {
//       console.error(`Error ${isBlocking ? 'blocking' : 'unblocking'} user:`, error);
//       alert(`Failed to ${isBlocking ? 'block' : 'unblock'} user`);
//     } finally {
//       setActionLoading(prev => ({ ...prev, [selectedUser.uid]: false }));
//     }
//   };

//   const navigateToProfile = (user) => {
//     const routes = {
//       'LeadGenerator': `/admin/lead-generator/${user.leadGeneratorId || user.uid}`,
//       'Hospital': `/admin/hospital/${user.hospitalId || user.uid}`,
//       'Doctor': `/admin/doctor/${user.uid}`,
//       'FinancialTeam': `/admin/financial-team/${user.uid}`,
//       'PolicyWriter': `/admin/policy-writer/${user.uid}`
//     };

//     const route = routes[user.role];
//     if (route) {
//       navigate(route);
//     } else {
//       navigate(`/admin/user/${user.uid}`);
//     }
//   };

//   const getUserStatusBadge = (user) => {
//     if (user.isBlocked) {
//       return (
//         <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800">
//           <Ban className="h-3 w-3 mr-1" />
//           Blocked
//         </span>
//       );
//     } else if (!user.isActive) {
//       return (
//         <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
//           <UserX className="h-3 w-3 mr-1" />
//           Inactive
//         </span>
//       );
//     } else {
//       return (
//         <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
//           <UserCheck className="h-3 w-3 mr-1" />
//           Active
//         </span>
//       );
//     }
//   };

//   const getRoleIcon = (role) => {
//     const roleConfig = userRoles.find(r => r.value === role);
//     if (roleConfig) {
//       const IconComponent = roleConfig.icon;
//       return <IconComponent className={`h-4 w-4 ${roleConfig.color}`} />;
//     }
//     return <Users className="h-4 w-4 text-gray-600" />;
//   };

//   const formatDate = (timestamp) => {
//     if (!timestamp) return 'N/A';
//     const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
//     return date.toLocaleDateString('en-IN', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit'
//     });
//   };

//   if (loading) {
//     return (
//       <div className="min-h-screen bg-gradient-to-br from-teal-50 via-cyan-50 to-blue-50 flex items-center justify-center">
//         <div className="text-center">
//           <RefreshCw className="h-8 w-8 animate-spin text-teal-500 mx-auto mb-4" />
//           <p className="text-gray-600">Loading users...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-teal-50 via-cyan-50 to-blue-50">
//       {/* Header */}
//       <div className="bg-white shadow-sm border-b border-gray-200">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="flex items-center justify-between py-6">
//             <div>
//               <h1 className="text-3xl font-bold text-gray-900">User Management</h1>
//               <p className="text-gray-600 mt-1">Manage all users across the platform</p>
//             </div>

//             <div className="flex items-center space-x-4">
//               <button
//                 onClick={() => setShowFilters(!showFilters)}
//                 className={`inline-flex items-center px-4 py-2 border border-gray-300 rounded-lg font-medium transition-colors ${
//                   showFilters ? 'bg-teal-50 text-teal-700 border-teal-300' : 'text-gray-700 hover:bg-gray-50'
//                 }`}
//               >
//                 <Filter className="h-4 w-4 mr-2" />
//                 Filters
//               </button>
              
//               <button
//                 onClick={loadUsers}
//                 className="inline-flex items-center px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
//               >
//                 <RefreshCw className="h-4 w-4 mr-2" />
//                 Refresh
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
//         {/* Stats Cards */}
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
//           <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
//             <div className="flex items-center justify-between">
//               <div>
//                 <p className="text-sm font-medium text-gray-500">Total Users</p>
//                 <p className="text-3xl font-bold text-gray-900">{stats.totalUsers || users.length}</p>
//               </div>
//               <div className="bg-blue-100 p-3 rounded-lg">
//                 <Users className="h-6 w-6 text-blue-600" />
//               </div>
//             </div>
//           </div>

//           <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
//             <div className="flex items-center justify-between">
//               <div>
//                 <p className="text-sm font-medium text-gray-500">Active Users</p>
//                 <p className="text-3xl font-bold text-green-600">
//                   {users.filter(u => u.isActive && !u.isBlocked).length}
//                 </p>
//               </div>
//               <div className="bg-green-100 p-3 rounded-lg">
//                 <UserCheck className="h-6 w-6 text-green-600" />
//               </div>
//             </div>
//           </div>

//           <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
//             <div className="flex items-center justify-between">
//               <div>
//                 <p className="text-sm font-medium text-gray-500">Blocked Users</p>
//                 <p className="text-3xl font-bold text-red-600">
//                   {users.filter(u => u.isBlocked).length}
//                 </p>
//               </div>
//               <div className="bg-red-100 p-3 rounded-lg">
//                 <Ban className="h-6 w-6 text-red-600" />
//               </div>
//             </div>
//           </div>

//           <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
//             <div className="flex items-center justify-between">
//               <div>
//                 <p className="text-sm font-medium text-gray-500">This Month</p>
//                 <p className="text-3xl font-bold text-purple-600">
//                   {users.filter(u => {
//                     const userDate = u.createdAt?.toDate ? u.createdAt.toDate() : new Date(u.createdAt);
//                     const thisMonth = new Date();
//                     thisMonth.setDate(1);
//                     return userDate >= thisMonth;
//                   }).length}
//                 </p>
//               </div>
//               <div className="bg-purple-100 p-3 rounded-lg">
//                 <Calendar className="h-6 w-6 text-purple-600" />
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Filters */}
//         {showFilters && (
//           <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-6">
//             <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">Search Users</label>
//                 <div className="relative">
//                   <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
//                   <input
//                     type="text"
//                     value={searchTerm}
//                     onChange={(e) => setSearchTerm(e.target.value)}
//                     className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
//                     placeholder="Search by name, email, phone..."
//                   />
//                 </div>
//               </div>

//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">User Role</label>
//                 <select
//                   value={selectedRole}
//                   onChange={(e) => setSelectedRole(e.target.value)}
//                   className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
//                 >
//                   {userRoles.map(role => (
//                     <option key={role.value} value={role.value}>{role.label}</option>
//                   ))}
//                 </select>
//               </div>

//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">Status</label>
//                 <select
//                   value={selectedStatus}
//                   onChange={(e) => setSelectedStatus(e.target.value)}
//                   className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
//                 >
//                   <option value="all">All Status</option>
//                   <option value="active">Active</option>
//                   <option value="blocked">Blocked</option>
//                   <option value="inactive">Inactive</option>
//                 </select>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Users Table */}
//         <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
//           <div className="px-6 py-4 border-b border-gray-200">
//             <div className="flex items-center justify-between">
//               <h3 className="text-lg font-semibold text-gray-900">
//                 Users ({filteredUsers.length})
//               </h3>
//               <div className="text-sm text-gray-500">
//                 Showing {filteredUsers.length} of {users.length} users
//               </div>
//             </div>
//           </div>

//           <div className="overflow-x-auto">
//             <table className="min-w-full divide-y divide-gray-200">
//               <thead className="bg-gray-50">
//                 <tr>
//                   <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                     User
//                   </th>
//                   <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                     Role
//                   </th>
//                   <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                     Contact
//                   </th>
//                   <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                     Status
//                   </th>
//                   <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                     Created
//                   </th>
//                   <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
//                     Actions
//                   </th>
//                 </tr>
//               </thead>
//               <tbody className="bg-white divide-y divide-gray-200">
//                 {filteredUsers.map((user) => (
//                   <tr key={user.uid} className="hover:bg-gray-50">
//                     <td className="px-6 py-4 whitespace-nowrap">
//                       <div className="flex items-center">
//                         <div className="flex-shrink-0 h-10 w-10">
//                           <div className={`h-10 w-10 rounded-full flex items-center justify-center ${
//                             userRoles.find(r => r.value === user.role)?.bgColor || 'bg-gray-100'
//                           }`}>
//                             {getRoleIcon(user.role)}
//                           </div>
//                         </div>
//                         <div className="ml-4">
//                           <div className="text-sm font-medium text-gray-900">
//                             {user.profile?.name || user.entityName || user.hospitalName || 'N/A'}
//                           </div>
//                           <div className="text-sm text-gray-500">{user.email}</div>
//                         </div>
//                       </div>
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap">
//                       <div className="flex items-center">
//                         {getRoleIcon(user.role)}
//                         <span className="ml-2 text-sm text-gray-900">{user.role}</span>
//                       </div>
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap">
//                       <div className="text-sm text-gray-900">
//                         <div className="flex items-center mb-1">
//                           <Phone className="h-3 w-3 text-gray-400 mr-1" />
//                           {user.profile?.phone || 'N/A'}
//                         </div>
//                         <div className="flex items-center">
//                           <Mail className="h-3 w-3 text-gray-400 mr-1" />
//                           {user.profile?.email || user.email}
//                         </div>
//                       </div>
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap">
//                       {getUserStatusBadge(user)}
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                       {formatDate(user.createdAt)}
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
//                       <div className="flex items-center justify-end space-x-2">
//                         <button
//                           onClick={() => navigateToProfile(user)}
//                           className="text-teal-600 hover:text-teal-900 transition-colors"
//                           title="View Profile"
//                         >
//                           <Eye className="h-4 w-4" />
//                         </button>
                        
//                         <button
//                           onClick={() => {
//                             setSelectedUser(user);
//                             setActionType(user.isBlocked ? 'unblock' : 'block');
//                             setShowActionModal(true);
//                           }}
//                           className={`transition-colors ${
//                             user.isBlocked 
//                               ? 'text-green-600 hover:text-green-900' 
//                               : 'text-red-600 hover:text-red-900'
//                           }`}
//                           title={user.isBlocked ? 'Unblock User' : 'Block User'}
//                           disabled={actionLoading[user.uid]}
//                         >
//                           {user.isBlocked ? (
//                             <Unlock className="h-4 w-4" />
//                           ) : (
//                             <Ban className="h-4 w-4" />
//                           )}
//                         </button>
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           {filteredUsers.length === 0 && (
//             <div className="text-center py-12">
//               <Users className="h-12 w-12 text-gray-400 mx-auto mb-4" />
//               <h3 className="text-lg font-medium text-gray-900 mb-2">No users found</h3>
//               <p className="text-gray-600">Try adjusting your search or filter criteria.</p>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Block/Unblock Action Modal */}
//       {showActionModal && selectedUser && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
//           <div className="bg-white rounded-lg max-w-md w-full p-6">
//             <div className="flex items-center justify-between mb-4">
//               <h3 className="text-lg font-semibold text-gray-900">
//                 {actionType === 'block' ? 'Block User' : 'Unblock User'}
//               </h3>
//               <button
//                 onClick={() => setShowActionModal(false)}
//                 className="text-gray-400 hover:text-gray-600"
//               >
//                 <X className="h-6 w-6" />
//               </button>
//             </div>

//             <div className="mb-6">
//               <div className={`border rounded-lg p-4 mb-4 ${
//                 actionType === 'block' 
//                   ? 'bg-red-50 border-red-200' 
//                   : 'bg-green-50 border-green-200'
//               }`}>
//                 <div className="flex items-center space-x-3">
//                   {actionType === 'block' ? (
//                     <Ban className="h-5 w-5 text-red-600" />
//                   ) : (
//                     <Unlock className="h-5 w-5 text-green-600" />
//                   )}
//                   <div>
//                     <h4 className={`font-medium ${
//                       actionType === 'block' ? 'text-red-800' : 'text-green-800'
//                     }`}>
//                       {actionType === 'block' ? 'Block User Account' : 'Unblock User Account'}
//                     </h4>
//                     <p className={`text-sm ${
//                       actionType === 'block' ? 'text-red-600' : 'text-green-600'
//                     }`}>
//                       {actionType === 'block' 
//                         ? `${selectedUser.profile?.name || selectedUser.email} will lose access to their account`
//                         : `${selectedUser.profile?.name || selectedUser.email} will regain access to their account`
//                       }
//                     </p>
//                   </div>
//                 </div>
//               </div>

//               {actionType === 'block' && (
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-2">
//                     Block Reason *
//                   </label>
//                   <textarea
//                     value={actionReason}
//                     onChange={(e) => setActionReason(e.target.value)}
//                     rows="3"
//                     className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
//                     placeholder="Provide reason for blocking this user..."
//                     required
//                   />
//                   <p className="text-xs text-gray-500 mt-1">
//                     This reason will be logged for audit purposes
//                   </p>
//                 </div>
//               )}
//             </div>

//             <div className="flex justify-end space-x-3">
//               <button
//                 onClick={() => setShowActionModal(false)}
//                 className="inline-flex items-center px-4 py-2 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleUserAction}
//                 disabled={(actionType === 'block' && !actionReason.trim()) || actionLoading[selectedUser.uid]}
//                 className={`inline-flex items-center px-4 py-2 font-medium rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${
//                   actionType === 'block'
//                     ? 'bg-red-600 text-white hover:bg-red-700'
//                     : 'bg-green-600 text-white hover:bg-green-700'
//                 }`}
//               >
//                 {actionLoading[selectedUser.uid] ? (
//                   <>
//                     <RefreshCw className="h-4 w-4 mr-2 animate-spin" />
//                     {actionType === 'block' ? 'Blocking...' : 'Unblocking...'}
//                   </>
//                 ) : (
//                   <>
//                     {actionType === 'block' ? (
//                       <>
//                         <Ban className="h-4 w-4 mr-2" />
//                         Block User
//                       </>
//                     ) : (
//                       <>
//                         <Unlock className="h-4 w-4 mr-2" />
//                         Unblock User
//                       </>
//                     )}
//                   </>
//                 )}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default UserManagement;

// File Location: src/pages/admin/UserManagement.jsx

import React, { useState, useEffect } from 'react';
import ClampedText from '../../components/common/ClampedText.jsx';
import { useNavigate } from 'react-router-dom';
import {
  Users,
  Search,
  Filter,
  MoreVertical,
  Eye,
  Trash2,
  Ban,
  Unlock,
  UserCheck,
  UserX,
  Building2,
  Stethoscope,
  CreditCard,
  FileText,
  TrendingUp,
  Calendar,
  Mail,
  Phone,
  Shield,
  AlertTriangle,
  CheckCircle,
  Clock,
  Download,
  RefreshCw,
  Plus,
  Settings,
  Activity,
  UserPlus,
  X,
  EyeOff,
  Loader
} from 'lucide-react';
import { 
  getAllUsers, 
  blockUser, 
  unblockUser, 
  getUserStats,
  createUser,
  updateUserFields,
  deleteUser
} from '../../services/userService';
import { useAuth } from '../../context/AuthContext';

const UserManagement = () => {
  const navigate = useNavigate();
  const { userData } = useAuth();
  
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState({});
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedRole, setSelectedRole] = useState('all');
  const [selectedStatus, setSelectedStatus] = useState('all');
  const [showFilters, setShowFilters] = useState(false);
  const [stats, setStats] = useState({});
  const [selectedUser, setSelectedUser] = useState(null);
  const [showActionModal, setShowActionModal] = useState(false);
  const [actionType, setActionType] = useState('');
  const [actionReason, setActionReason] = useState('');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteReason, setDeleteReason] = useState('');
  const [deletingUser, setDeletingUser] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editForm, setEditForm] = useState({ profile: { name: '', phone: '', email: '' }, role: '', roles: [], isActive: true });
  const [savingEdit, setSavingEdit] = useState(false);

  // Add User Modal States
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const [newUserData, setNewUserData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
  role: '', // primary role for backward compatibility
  roles: [], // multi-role support
    phone: '',
    designation: '',
    department: '',
    employeeId: '',
    isActive: true
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [addUserErrors, setAddUserErrors] = useState({});
  const [addingUser, setAddingUser] = useState(false);

  // User roles configuration
  const userRoles = [
    { 
      value: 'all', 
      label: 'All Users', 
      icon: Users, 
      color: 'text-gray-600',
      bgColor: 'bg-gray-100' 
    },
    { 
      value: 'SystemAdmin', 
      label: 'System Admins', 
      icon: Shield, 
      color: 'text-indigo-600',
      bgColor: 'bg-indigo-100' 
    },
    { 
      value: 'LeadGenerator', 
      label: 'Lead Generators', 
      icon: TrendingUp, 
      color: 'text-teal-600',
      bgColor: 'bg-teal-100' 
    },
    { 
      value: 'Hospital', 
      label: 'Hospitals', 
      icon: Building2, 
      color: 'text-blue-600',
      bgColor: 'bg-blue-100' 
    },
    { 
      value: 'Doctor', 
      label: 'Doctors', 
      icon: Stethoscope, 
      color: 'text-green-600',
      bgColor: 'bg-green-100' 
    },
    { 
      value: 'FinancialTeam', 
      label: 'Financial Team', 
      icon: CreditCard, 
      color: 'text-purple-600',
      bgColor: 'bg-purple-100' 
    },
    { 
      value: 'PolicyWriter', 
      label: 'Policy Writers', 
      icon: FileText, 
      color: 'text-orange-600',
      bgColor: 'bg-orange-100' 
    }
  ];

  // Available roles for user creation (excluding 'all')
  const availableRoles = userRoles.filter(role => role.value !== 'all');

  useEffect(() => {
    loadUsers();
    loadStats();
  }, []);

  useEffect(() => {
    filterUsers();
  }, [users, searchTerm, selectedRole, selectedStatus]);

  const loadUsers = async () => {
    setLoading(true);
    try {
      const result = await getAllUsers();
      if (result.success) {
        setUsers(result.users);
      } else {
        console.error('Error loading users:', result.error);
      }
    } catch (error) {
      console.error('Error loading users:', error);
    } finally {
      setLoading(false);
    }
  };

  const loadStats = async () => {
    try {
      const result = await getUserStats();
      if (result.success) {
        setStats(result.stats);
      }
    } catch (error) {
      console.error('Error loading stats:', error);
    }
  };

  const filterUsers = () => {
    let filtered = [...users];

    // Filter by search term
    if (searchTerm) {
      filtered = filtered.filter(user => 
        user.profile?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        user.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        user.entityName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        user.hospitalName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        user.profile?.phone?.includes(searchTerm)
      );
    }

    // Filter by role (support legacy primary role and new multi-role array)
    if (selectedRole !== 'all') {
      filtered = filtered.filter(user => {
        const rolesArr = Array.isArray(user.roles) ? user.roles : (user.role ? [user.role] : []);
        return user.role === selectedRole || rolesArr.includes(selectedRole);
      });
    }

    // Filter by status
    if (selectedStatus !== 'all') {
      if (selectedStatus === 'active') {
        filtered = filtered.filter(user => user.isActive && !user.isBlocked);
      } else if (selectedStatus === 'blocked') {
        filtered = filtered.filter(user => user.isBlocked);
      } else if (selectedStatus === 'inactive') {
        filtered = filtered.filter(user => !user.isActive);
      }
    }

    setFilteredUsers(filtered);
  };

  const handleUserAction = async () => {
    if (!selectedUser || !actionType) return;

    const isBlocking = actionType === 'block';
    if (isBlocking && !actionReason.trim()) return;

    setActionLoading(prev => ({ ...prev, [selectedUser.uid]: true }));
    
    try {
      const result = isBlocking 
        ? await blockUser(selectedUser.uid, userData.uid, actionReason)
        : await unblockUser(selectedUser.uid, userData.uid);

      if (result.success) {
        // Update local state
        setUsers(prev => prev.map(user => 
          user.uid === selectedUser.uid 
            ? { 
                ...user, 
                isBlocked: isBlocking,
                blockedBy: isBlocking ? userData.uid : null,
                blockedAt: isBlocking ? new Date() : null,
                blockReason: isBlocking ? actionReason : null,
                unblockedAt: isBlocking ? null : new Date()
              }
            : user
        ));
        
        setShowActionModal(false);
        setSelectedUser(null);
        setActionReason('');
        alert(`User ${isBlocking ? 'blocked' : 'unblocked'} successfully!`);
      } else {
        alert(`Error ${isBlocking ? 'blocking' : 'unblocking'} user: ` + result.error);
      }
    } catch (error) {
      console.error(`Error ${isBlocking ? 'blocking' : 'unblocking'} user:`, error);
      alert(`Failed to ${isBlocking ? 'block' : 'unblock'} user`);
    } finally {
      setActionLoading(prev => ({ ...prev, [selectedUser.uid]: false }));
    }
  };

  const handleDeleteUser = async () => {
    if (!selectedUser) return;
    if (!deleteReason.trim()) return;
    setDeletingUser(true);
    try {
      const res = await deleteUser(selectedUser.uid, userData.uid, deleteReason.trim());
      if (res.success) {
        setUsers(prev => prev.filter(u => u.uid !== selectedUser.uid));
        setShowDeleteModal(false);
        setSelectedUser(null);
        setDeleteReason('');
        alert('User permanently deleted');
        loadStats();
      } else {
        alert(res.error || 'Failed to delete user');
      }
    } catch (e) {
      console.error('Delete user failed', e);
      alert('Failed to delete user');
    } finally {
      setDeletingUser(false);
    }
  };

  // Add User Functions
  const validateNewUser = () => {
    const errors = {};

    if (!newUserData.name.trim()) errors.name = 'Name is required';
    if (!newUserData.email.trim()) errors.email = 'Email is required';
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(newUserData.email)) {
      errors.email = 'Invalid email format';
    }
    if (!newUserData.password) errors.password = 'Password is required';
    else if (newUserData.password.length < 8) {
      errors.password = 'Password must be at least 8 characters';
    }
    if (!newUserData.confirmPassword) errors.confirmPassword = 'Confirm password is required';
    else if (newUserData.password !== newUserData.confirmPassword) {
      errors.confirmPassword = 'Passwords do not match';
    }
    // Multi-role validation: require at least one selection
    if (!Array.isArray(newUserData.roles) || newUserData.roles.length === 0) {
      errors.roles = 'Select at least one role';
    }
    // Ensure primary role is set when roles are selected
    if ((newUserData.roles?.length || 0) > 0 && !newUserData.role) {
      // default primary to first selected
      setNewUserData(prev => ({ ...prev, role: prev.roles[0] }));
    }
    if (newUserData.phone && !/^[6-9]\d{9}$/.test(newUserData.phone.replace(/\s+/g, ''))) {
      errors.phone = 'Invalid phone number format';
    }

    setAddUserErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleAddUser = async () => {
    if (!validateNewUser()) return;

    setAddingUser(true);
    try {
      const result = await createUser({
  ...newUserData,
  // Backward compatibility: ensure primary role is set
  role: newUserData.role || newUserData.roles?.[0] || '',
  roles: Array.isArray(newUserData.roles) ? newUserData.roles : (newUserData.role ? [newUserData.role] : []),
        createdBy: userData.uid
      });

      if (result.success) {
        // Add new user to local state
        setUsers(prev => [result.user, ...prev]);
        
        // Reset form and close modal
        setNewUserData({
          name: '',
          email: '',
          password: '',
          confirmPassword: '',
          role: '',
          roles: [],
          phone: '',
          designation: '',
          department: '',
          employeeId: '',
          isActive: true
        });
        setAddUserErrors({});
        setShowAddUserModal(false);
        
        alert('User created successfully!');
        loadStats(); // Refresh stats
      } else {
        setAddUserErrors({ submit: result.error });
      }
    } catch (error) {
      console.error('Error creating user:', error);
      setAddUserErrors({ submit: 'Failed to create user. Please try again.' });
    } finally {
      setAddingUser(false);
    }
  };

  const handleNewUserInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setNewUserData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    
    // Clear error when user starts typing
    if (addUserErrors[name]) {
      setAddUserErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  // Edit user helpers
  const openEditUser = (user) => {
    const roles = Array.isArray(user.roles) ? user.roles : (user.role ? [user.role] : []);
    setEditForm({
      profile: {
        name: user.profile?.name || '',
        phone: user.profile?.phone || '',
        email: user.profile?.email || user.email || '',
      },
      role: user.role || roles[0] || '',
      roles,
      isActive: user.isActive !== false,
    });
    setSelectedUser(user);
    setShowEditModal(true);
  };

  const handleEditInputChange = (e) => {
    const { name, value } = e.target;
    if (name.startsWith('profile.')) {
      const key = name.split('.')[1];
      setEditForm(prev => ({ ...prev, profile: { ...prev.profile, [key]: value } }));
    } else {
      setEditForm(prev => ({ ...prev, [name]: value }));
    }
  };

  const toggleEditRole = (roleValue) => {
    setEditForm(prev => {
      const s = new Set(prev.roles || []);
      if (s.has(roleValue)) s.delete(roleValue); else s.add(roleValue);
      const roles = Array.from(s);
      let primary = prev.role;
      if (roles.length === 0) primary = ''; else if (!roles.includes(primary)) primary = roles[0];
      return { ...prev, roles, role: primary };
    });
  };

  const saveEditUser = async () => {
    if (!selectedUser) return;
    if (!editForm.roles || editForm.roles.length === 0) {
      alert('Select at least one role');
      return;
    }
    setSavingEdit(true);
    try {
      const result = await updateUserFields(selectedUser.uid, {
        profile: editForm.profile,
        role: editForm.role || editForm.roles[0],
        roles: editForm.roles,
        isActive: !!editForm.isActive,
      }, userData.uid);
      if (result.success) {
        setUsers(prev => prev.map(u => u.uid === selectedUser.uid ? {
          ...u,
          profile: { ...u.profile, ...editForm.profile },
          role: editForm.role || editForm.roles[0],
          roles: editForm.roles,
          isActive: !!editForm.isActive,
          updatedAt: new Date(),
        } : u));
        setShowEditModal(false);
        setSelectedUser(null);
      } else {
        alert(result.error || 'Failed to update user');
      }
    } catch (e) {
      console.error('saveEditUser error', e);
      alert('Failed to update user');
    } finally {
      setSavingEdit(false);
    }
  };

  // Toggle a role in roles[] and maintain primary role
  const toggleRoleSelection = (roleValue) => {
    setNewUserData(prev => {
      const roles = new Set(prev.roles || []);
      if (roles.has(roleValue)) {
        roles.delete(roleValue);
      } else {
        roles.add(roleValue);
      }
      const updated = Array.from(roles);
      // Adjust primary role if needed
      let primary = prev.role;
      if (updated.length === 0) {
        primary = '';
      } else if (!updated.includes(primary)) {
        primary = updated[0];
      }
      // Clear any prior errors related to roles
      if (addUserErrors.roles) setAddUserErrors(p => ({ ...p, roles: '' }));
      return { ...prev, roles: updated, role: primary };
    });
  };

  const navigateToProfile = (user) => {
    const routes = {
      'LeadGenerator': `/admin/lead-generator/${user.leadGeneratorId || user.uid}`,
      'Hospital': `/admin/hospital/${user.hospitalId || user.uid}`,
      'Doctor': `/admin/doctor/${user.uid}`,
      'FinancialTeam': `/admin/financial-team/${user.uid}`,
      'PolicyWriter': `/admin/policy-writer/${user.uid}`
    };

    const route = routes[user.role];
    if (route) {
      navigate(route);
    } else {
      navigate(`/admin/user/${user.uid}`);
    }
  };

  const getUserStatusBadge = (user) => {
    if (user.isBlocked) {
      return (
        <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800">
          <Ban className="h-3 w-3 mr-1" />
          Blocked
        </span>
      );
    } else if (!user.isActive) {
      return (
        <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
          <UserX className="h-3 w-3 mr-1" />
          Inactive
        </span>
      );
    } else {
      return (
        <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
          <UserCheck className="h-3 w-3 mr-1" />
          Active
        </span>
      );
    }
  };

  const getRoleIcon = (role) => {
    const roleConfig = userRoles.find(r => r.value === role);
    if (roleConfig) {
      const IconComponent = roleConfig.icon;
      return <IconComponent className={`h-4 w-4 ${roleConfig.color}`} />;
    }
    return <Users className="h-4 w-4 text-gray-600" />;
  };

  const formatDate = (timestamp) => {
    if (!timestamp) return 'N/A';
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    return date.toLocaleDateString('en-IN', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-teal-50 via-cyan-50 to-blue-50 flex items-center justify-center">
        <div className="text-center">
          <RefreshCw className="h-8 w-8 animate-spin text-teal-500 mx-auto mb-4" />
          <p className="text-gray-600">Loading users...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 via-cyan-50 to-blue-50">
      {/* Header */}
      <div className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between py-6">
            <div>
              <h1 className="text-3xl font-bold text-gray-900">User Management</h1>
              <p className="text-gray-600 mt-1">Manage all users across the platform</p>
            </div>

            <div className="flex items-center space-x-4">
              <button
                onClick={() => setShowFilters(!showFilters)}
                className={`inline-flex items-center px-4 py-2 border border-gray-300 rounded-lg font-medium transition-colors ${
                  showFilters ? 'bg-teal-50 text-teal-700 border-teal-300' : 'text-gray-700 hover:bg-gray-50'
                }`}
              >
                <Filter className="h-4 w-4 mr-2" />
                Filters
              </button>
              
              <button
                onClick={loadUsers}
                className="inline-flex items-center px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
              >
                <RefreshCw className="h-4 w-4 mr-2" />
                Refresh
              </button>

              <button
                onClick={() => setShowAddUserModal(true)}
                className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-teal-500 to-cyan-500 text-white font-medium rounded-lg hover:from-teal-600 hover:to-cyan-600 transition-all shadow-sm"
              >
                <UserPlus className="h-4 w-4 mr-2" />
                Add User
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-500">Total Users</p>
                <p className="text-3xl font-bold text-gray-900">{stats.totalUsers || users.length}</p>
              </div>
              <div className="bg-blue-100 p-3 rounded-lg">
                <Users className="h-6 w-6 text-blue-600" />
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-500">Active Users</p>
                <p className="text-3xl font-bold text-green-600">
                  {users.filter(u => u.isActive && !u.isBlocked).length}
                </p>
              </div>
              <div className="bg-green-100 p-3 rounded-lg">
                <UserCheck className="h-6 w-6 text-green-600" />
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-500">Blocked Users</p>
                <p className="text-3xl font-bold text-red-600">
                  {users.filter(u => u.isBlocked).length}
                </p>
              </div>
              <div className="bg-red-100 p-3 rounded-lg">
                <Ban className="h-6 w-6 text-red-600" />
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-500">This Month</p>
                <p className="text-3xl font-bold text-purple-600">
                  {users.filter(u => {
                    const userDate = u.createdAt?.toDate ? u.createdAt.toDate() : new Date(u.createdAt);
                    const thisMonth = new Date();
                    thisMonth.setDate(1);
                    return userDate >= thisMonth;
                  }).length}
                </p>
              </div>
              <div className="bg-purple-100 p-3 rounded-lg">
                <Calendar className="h-6 w-6 text-purple-600" />
              </div>
            </div>
          </div>
        </div>

        {/* Filters */}
        {showFilters && (
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Search Users</label>
                <div className="relative">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
                  <input
                    type="text"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                    placeholder="Search by name, email, phone..."
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">User Role</label>
                <select
                  value={selectedRole}
                  onChange={(e) => setSelectedRole(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                >
                  {userRoles.map(role => (
                    <option key={role.value} value={role.value}>{role.label}</option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Status</label>
                <select
                  value={selectedStatus}
                  onChange={(e) => setSelectedStatus(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                >
                  <option value="all">All Status</option>
                  <option value="active">Active</option>
                  <option value="blocked">Blocked</option>
                  <option value="inactive">Inactive</option>
                </select>
              </div>
            </div>
          </div>
        )}

        {/* Users Table */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
          <div className="px-6 py-4 border-b border-gray-200">
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-semibold text-gray-900">
                Users ({filteredUsers.length})
              </h3>
              <div className="text-sm text-gray-500">
                Showing {filteredUsers.length} of {users.length} users
              </div>
            </div>
          </div>

          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    User
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Role
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Contact
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Status
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Created
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {filteredUsers.map((user) => (
                  <tr key={user.uid} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-normal">
                      <div className="flex items-center">
                        <div className="flex-shrink-0 h-10 w-10">
                          <div className={`h-10 w-10 rounded-full flex items-center justify-center ${
                            userRoles.find(r => r.value === user.role)?.bgColor || 'bg-gray-100'
                          }`}>
                            {getRoleIcon(user.role)}
                          </div>
                        </div>
                        <div className="ml-4">
                          <ClampedText className="text-sm font-medium text-gray-900" value={user.profile?.name || user.entityName || user.hospitalName || 'N/A'} />
                          <ClampedText className="text-sm text-gray-500" value={user.email} />
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-normal">
                      <div className="flex items-center">
                        {getRoleIcon(user.role)}
                        <ClampedText as="span" className="ml-2 text-sm text-gray-900" value={user.role} />
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-normal">
                      <div className="text-sm text-gray-900">
                        <div className="flex items-center mb-1">
                          <Phone className="h-3 w-3 text-gray-400 mr-1" />
                          <ClampedText as="span" value={user.profile?.phone || 'N/A'} />
                        </div>
                        <div className="flex items-center">
                          <Mail className="h-3 w-3 text-gray-400 mr-1" />
                          <ClampedText as="span" value={user.profile?.email || user.email} />
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {getUserStatusBadge(user)}
                    </td>
                    <td className="px-6 py-4 whitespace-normal text-sm text-gray-500">
                      <ClampedText value={formatDate(user.createdAt)} />
                    </td>
                    <td className="px-6 py-4 whitespace-normal text-right text-sm font-medium">
                      <div className="flex items-center justify-end space-x-2">
                        <button
                          onClick={() => openEditUser(user)}
                          className="text-teal-600 hover:text-teal-900 transition-colors"
                          title="View & Edit User"
                        >
                          <Eye className="h-4 w-4" />
                        </button>
                        <button
                          onClick={() => { setSelectedUser(user); setShowDeleteModal(true); setDeleteReason(''); }}
                          className="text-red-600 hover:text-red-900 transition-colors"
                          title="Delete User Permanently"
                        >
                          <Trash2 className="h-4 w-4" />
                        </button>
                        
                        <button
                          onClick={() => {
                            setSelectedUser(user);
                            setActionType(user.isBlocked ? 'unblock' : 'block');
                            setShowActionModal(true);
                          }}
                          className={`transition-colors ${
                            user.isBlocked 
                              ? 'text-green-600 hover:text-green-900' 
                              : 'text-red-600 hover:text-red-900'
                          }`}
                          title={user.isBlocked ? 'Unblock User' : 'Block User'}
                          disabled={actionLoading[user.uid]}
                        >
                          {user.isBlocked ? (
                            <Unlock className="h-4 w-4" />
                          ) : (
                            <Ban className="h-4 w-4" />
                          )}
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {filteredUsers.length === 0 && (
            <div className="text-center py-12">
              <Users className="h-12 w-12 text-gray-400 mx-auto mb-4" />
              <h3 className="text-lg font-medium text-gray-900 mb-2">No users found</h3>
              <p className="text-gray-600">Try adjusting your search or filter criteria.</p>
            </div>
          )}
        </div>
      </div>

      {/* Add User Modal */}
      {showAddUserModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg max-w-2xl w-full p-6 max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-xl font-semibold text-gray-900">Add New User</h3>
              <button
                onClick={() => {
                  setShowAddUserModal(false);
                  setNewUserData({
                    name: '',
                    email: '',
                    password: '',
                    confirmPassword: '',
                    role: '',
                    phone: '',
                    designation: '',
                    department: '',
                    employeeId: '',
                    isActive: true
                  });
                  setAddUserErrors({});
                }}
                className="text-gray-400 hover:text-gray-600"
              >
                <X className="h-6 w-6" />
              </button>
            </div>

            <div className="space-y-6">
              {/* Basic Information */}
              <div className="bg-teal-50 rounded-lg p-4 border border-teal-200">
                <h4 className="font-medium text-teal-800 mb-2">Basic Information</h4>
                <p className="text-sm text-teal-600">
                  Create login credentials for the new user. They can update their profile after first login.
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Full Name *
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={newUserData.name}
                    onChange={handleNewUserInputChange}
                    className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500 ${
                      addUserErrors.name ? 'border-red-300' : 'border-gray-300'
                    }`}
                    placeholder="Enter full name"
                  />
                  {addUserErrors.name && <p className="text-sm text-red-600 mt-1">{addUserErrors.name}</p>}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Email Address *
                  </label>
                  <input
                    type="email"
                    name="email"
value={newUserData.email}
                    onChange={handleNewUserInputChange}
                    className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500 ${
                      addUserErrors.email ? 'border-red-300' : 'border-gray-300'
                    }`}
                    placeholder="user@example.com"
                  />
                  {addUserErrors.email && <p className="text-sm text-red-600 mt-1">{addUserErrors.email}</p>}
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Password *
                  </label>
                  <div className="relative">
                    <input
                      type={showPassword ? 'text' : 'password'}
                      name="password"
                      value={newUserData.password}
                      onChange={handleNewUserInputChange}
                      className={`w-full px-3 py-2 pr-10 border rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500 ${
                        addUserErrors.password ? 'border-red-300' : 'border-gray-300'
                      }`}
                      placeholder="Minimum 8 characters"
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute inset-y-0 right-0 pr-3 flex items-center"
                    >
                      {showPassword ? (
                        <EyeOff className="h-4 w-4 text-gray-400" />
                      ) : (
                        <Eye className="h-4 w-4 text-gray-400" />
                      )}
                    </button>
                  </div>
                  {addUserErrors.password && <p className="text-sm text-red-600 mt-1">{addUserErrors.password}</p>}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Confirm Password *
                  </label>
                  <div className="relative">
                    <input
                      type={showConfirmPassword ? 'text' : 'password'}
                      name="confirmPassword"
                      value={newUserData.confirmPassword}
                      onChange={handleNewUserInputChange}
                      className={`w-full px-3 py-2 pr-10 border rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500 ${
                        addUserErrors.confirmPassword ? 'border-red-300' : 'border-gray-300'
                      }`}
                      placeholder="Confirm password"
                    />
                    <button
                      type="button"
                      onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                      className="absolute inset-y-0 right-0 pr-3 flex items-center"
                    >
                      {showConfirmPassword ? (
                        <EyeOff className="h-4 w-4 text-gray-400" />
                      ) : (
                        <Eye className="h-4 w-4 text-gray-400" />
                      )}
                    </button>
                  </div>
                  {addUserErrors.confirmPassword && <p className="text-sm text-red-600 mt-1">{addUserErrors.confirmPassword}</p>}
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Multi-role selection */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Roles * (select one or more)
                  </label>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                    {availableRoles.map((role) => (
                      <label key={role.value} className="flex items-center space-x-2 p-2 border rounded-lg hover:bg-gray-50">
                        <input
                          type="checkbox"
                          checked={newUserData.roles?.includes(role.value) || false}
                          onChange={() => toggleRoleSelection(role.value)}
                          className="rounded border-gray-300 text-teal-600 focus:ring-teal-500"
                        />
                        <span className="text-sm text-gray-700 flex items-center">
                          <role.icon className={`h-4 w-4 mr-2 ${role.color}`} />
                          {role.label}
                        </span>
                      </label>
                    ))}
                  </div>
                  {addUserErrors.roles && <p className="text-sm text-red-600 mt-1">{addUserErrors.roles}</p>}
                  {newUserData.roles?.length > 0 && (
                    <div className="mt-3">
                      <div className="text-xs text-gray-600 mb-1">Selected roles:</div>
                      <div className="flex flex-wrap gap-2">
                        {newUserData.roles.map((r) => (
                          <span key={r} className="px-2 py-1 text-xs rounded-full bg-teal-50 text-teal-700 border border-teal-200">
                            {availableRoles.find(ar => ar.value === r)?.label || r}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                </div>

                {/* Primary role selection */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Primary Role {newUserData.roles?.length > 0 ? '*' : ''}
                  </label>
                  <select
                    name="role"
                    value={newUserData.role}
                    onChange={handleNewUserInputChange}
                    disabled={!newUserData.roles || newUserData.roles.length === 0}
                    className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500 ${
                      addUserErrors.role ? 'border-red-300' : 'border-gray-300'
                    } ${(!newUserData.roles || newUserData.roles.length === 0) ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                  >
                    <option value="">{newUserData.roles?.length ? 'Select Primary Role' : 'Select roles first'}</option>
                    {availableRoles
                      .filter(r => newUserData.roles?.includes(r.value))
                      .map(role => (
                        <option key={role.value} value={role.value}>{role.label}</option>
                      ))}
                  </select>
                  {addUserErrors.role && <p className="text-sm text-red-600 mt-1">{addUserErrors.role}</p>}
                  <p className="text-xs text-gray-500 mt-1">Primary role is used for legacy features and default dashboard.</p>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Phone Number
                  </label>
                  <input
                    type="text"
                    name="phone"
                    value={newUserData.phone}
                    onChange={handleNewUserInputChange}
                    className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500 ${
                      addUserErrors.phone ? 'border-red-300' : 'border-gray-300'
                    }`}
                    placeholder="+91 XXXXX XXXXX"
                  />
                  {addUserErrors.phone && <p className="text-sm text-red-600 mt-1">{addUserErrors.phone}</p>}
                </div>
              </div>

              {/* Additional Information */}
              <div className="border-t border-gray-200 pt-6">
                <h4 className="font-medium text-gray-900 mb-4">Additional Information (Optional)</h4>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Designation
                    </label>
                    <input
                      type="text"
                      name="designation"
                      value={newUserData.designation}
                      onChange={handleNewUserInputChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                      placeholder="e.g., Senior Manager, Lead Developer"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Department
                    </label>
                    <input
                      type="text"
                      name="department"
                      value={newUserData.department}
                      onChange={handleNewUserInputChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                      placeholder="e.g., Finance, Operations, Medical"
                    />
                  </div>
                </div>

                <div className="mt-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Employee ID
                  </label>
                  <input
                    type="text"
                    name="employeeId"
                    value={newUserData.employeeId}
                    onChange={handleNewUserInputChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                    placeholder="e.g., EMP001, DOC123"
                  />
                </div>
              </div>

              {/* Account Status */}
              <div className="border-t border-gray-200 pt-6">
                <h4 className="font-medium text-gray-900 mb-4">Account Status</h4>
                
                <div className="flex items-center">
                  <input
                    type="checkbox"
                    name="isActive"
                    checked={newUserData.isActive}
                    onChange={handleNewUserInputChange}
                    className="rounded border-gray-300 text-teal-600 focus:ring-teal-500"
                  />
                  <label className="ml-2 text-sm text-gray-700">
                    Activate account immediately
                  </label>
                </div>
                <p className="text-xs text-gray-500 mt-1">
                  If unchecked, the user will need admin approval before they can access the system
                </p>
              </div>

              {/* Error Message */}
              {addUserErrors.submit && (
                <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                  <div className="flex items-center space-x-3">
                    <AlertTriangle className="h-5 w-5 text-red-600" />
                    <p className="text-red-700">{addUserErrors.submit}</p>
                  </div>
                </div>
              )}

              {/* Role-specific Information */}
              {(newUserData.role || (newUserData.roles?.length > 0)) && (
                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                  <div className="flex items-center space-x-3">
                    <CheckCircle className="h-5 w-5 text-blue-600" />
                    <div>
                      <h4 className="font-medium text-blue-800">
                        Creating {newUserData.roles?.length > 1 ? 'Multi-role' : availableRoles.find(r => r.value === newUserData.role)?.label} Account
                      </h4>
                      <p className="text-sm text-blue-600 mt-1">
                        The user will be able to access features specific to their selected roles after login.
                      </p>
                      {newUserData.roles?.length > 0 && (
                        <div className="mt-2 text-sm">
                          <span className="text-blue-700 font-medium">Roles:</span>{' '}
                          {newUserData.roles.map((r, idx) => (
                            <span key={r} className="inline-block mr-2">
                              {availableRoles.find(ar => ar.value === r)?.label || r}
                              {idx < newUserData.roles.length - 1 ? ',' : ''}
                            </span>
                          ))}
                          <div className="text-xs text-blue-700 mt-1">
                            Primary: {availableRoles.find(ar => ar.value === (newUserData.role || newUserData.roles?.[0]))?.label || newUserData.role}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Modal Actions */}
            <div className="flex justify-end space-x-3 pt-6 border-t border-gray-200 mt-6">
              <button
                onClick={() => {
                  setShowAddUserModal(false);
                  setNewUserData({
                    name: '',
                    email: '',
                    password: '',
                    confirmPassword: '',
                    role: '',
                    phone: '',
                    designation: '',
                    department: '',
                    employeeId: '',
                    isActive: true
                  });
                  setAddUserErrors({});
                }}
                className="inline-flex items-center px-4 py-2 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={handleAddUser}
                disabled={addingUser}
                className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-teal-500 to-cyan-500 text-white font-medium rounded-lg hover:from-teal-600 hover:to-cyan-600 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
              >
                {addingUser ? (
                  <>
                    <Loader className="h-4 w-4 mr-2 animate-spin" />
                    Creating User...
                  </>
                ) : (
                  <>
                    <UserPlus className="h-4 w-4 mr-2" />
                    Create User
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Block/Unblock Action Modal */}
      {showActionModal && selectedUser && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg max-w-md w-full p-6">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-gray-900">
                {actionType === 'block' ? 'Block User' : 'Unblock User'}
              </h3>
              <button
                onClick={() => setShowActionModal(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <X className="h-6 w-6" />
              </button>
            </div>

            <div className="mb-6">
              <div className={`border rounded-lg p-4 mb-4 ${
                actionType === 'block' 
                  ? 'bg-red-50 border-red-200' 
                  : 'bg-green-50 border-green-200'
              }`}>
                <div className="flex items-center space-x-3">
                  {actionType === 'block' ? (
                    <Ban className="h-5 w-5 text-red-600" />
                  ) : (
                    <Unlock className="h-5 w-5 text-green-600" />
                  )}
                  <div>
                    <h4 className={`font-medium ${
                      actionType === 'block' ? 'text-red-800' : 'text-green-800'
                    }`}>
                      {actionType === 'block' ? 'Block User Account' : 'Unblock User Account'}
                    </h4>
                    <p className={`text-sm ${
                      actionType === 'block' ? 'text-red-600' : 'text-green-600'
                    }`}>
                      {actionType === 'block' 
                        ? `${selectedUser.profile?.name || selectedUser.email} will lose access to their account`
                        : `${selectedUser.profile?.name || selectedUser.email} will regain access to their account`
                      }
                    </p>
                  </div>
                </div>
              </div>

              {actionType === 'block' && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Block Reason *
                  </label>
                  <textarea
                    value={actionReason}
                    onChange={(e) => setActionReason(e.target.value)}
                    rows="3"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                    placeholder="Provide reason for blocking this user..."
                    required
                  />
                  <p className="text-xs text-gray-500 mt-1">
                    This reason will be logged for audit purposes
                  </p>
                </div>
              )}
            </div>

            <div className="flex justify-end space-x-3">
              <button
                onClick={() => setShowActionModal(false)}
                className="inline-flex items-center px-4 py-2 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={handleUserAction}
                disabled={(actionType === 'block' && !actionReason.trim()) || actionLoading[selectedUser.uid]}
                className={`inline-flex items-center px-4 py-2 font-medium rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${
                  actionType === 'block'
                    ? 'bg-red-600 text-white hover:bg-red-700'
                    : 'bg-green-600 text-white hover:bg-green-700'
                }`}
              >
                {actionLoading[selectedUser.uid] ? (
                  <>
                    <RefreshCw className="h-4 w-4 mr-2 animate-spin" />
                    {actionType === 'block' ? 'Blocking...' : 'Unblocking...'}
                  </>
                ) : (
                  <>
                    {actionType === 'block' ? (
                      <>
                        <Ban className="h-4 w-4 mr-2" />
                        Block User
                      </>
                    ) : (
                      <>
                        <Unlock className="h-4 w-4 mr-2" />
                        Unblock User
                      </>
                    )}
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Delete User Modal */}
      {showDeleteModal && selectedUser && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg max-w-md w-full p-6">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-red-700">Delete User</h3>
              <button onClick={() => setShowDeleteModal(false)} className="text-gray-400 hover:text-gray-600">
                <X className="h-6 w-6" />
              </button>
            </div>
            <div className="space-y-4">
              <div className="bg-red-50 border border-red-200 rounded-lg p-3 text-sm text-red-700">
                This will permanently delete the user account from Firebase Auth and remove their Firestore user profile. This action cannot be undone.
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Reason for deletion *</label>
                <textarea value={deleteReason} onChange={(e) => setDeleteReason(e.target.value)} rows={3} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500" placeholder="Provide a brief reason" />
              </div>
            </div>
            <div className="flex justify-end space-x-3 mt-6">
              <button onClick={() => setShowDeleteModal(false)} className="inline-flex items-center px-4 py-2 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors">Cancel</button>
              <button onClick={handleDeleteUser} disabled={!deleteReason.trim() || deletingUser} className="inline-flex items-center px-4 py-2 bg-red-600 text-white font-medium rounded-lg hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed">
                {deletingUser ? 'Deleting…' : 'Delete User'}
              </button>
            </div>
          </div>
        </div>
      )}
      {/* View/Edit User Modal */}
      {showEditModal && selectedUser && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg max-w-2xl w-full p-6 max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-6">
              <div>
                <h3 className="text-xl font-semibold text-gray-900">View & Edit User</h3>
                <p className="text-sm text-gray-600">{selectedUser.email}</p>
              </div>
              <button onClick={() => { setShowEditModal(false); setSelectedUser(null); }} className="text-gray-400 hover:text-gray-600">
                <X className="h-6 w-6" />
              </button>
            </div>

            <div className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Full Name</label>
                  <input name="profile.name" value={editForm.profile.name} onChange={handleEditInputChange} className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500 border-gray-300" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Phone</label>
                  <input name="profile.phone" value={editForm.profile.phone} onChange={handleEditInputChange} className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500 border-gray-300" />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Login Email</label>
                <input name="profile.email" value={editForm.profile.email} onChange={handleEditInputChange} className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500 border-gray-300" />
                <p className="text-xs text-gray-500 mt-1">This updates the email in profile only. Changing Firebase Auth email needs a separate flow.</p>
              </div>

              {/* Roles */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Roles</label>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                    {availableRoles.map(role => (
                      <label key={role.value} className="flex items-center space-x-2 p-2 border rounded-lg hover:bg-gray-50">
                        <input type="checkbox" checked={editForm.roles?.includes(role.value) || false} onChange={() => toggleEditRole(role.value)} className="rounded border-gray-300 text-teal-600 focus:ring-teal-500" />
                        <span className="text-sm text-gray-700 flex items-center"><role.icon className={`h-4 w-4 mr-2 ${role.color}`} />{role.label}</span>
                      </label>
                    ))}
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Primary Role</label>
                  <select name="role" value={editForm.role} onChange={handleEditInputChange} disabled={!editForm.roles || editForm.roles.length === 0} className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500 ${(!editForm.roles || editForm.roles.length === 0) ? 'bg-gray-100 cursor-not-allowed' : 'border-gray-300'}`}>
                    <option value="">{editForm.roles?.length ? 'Select Primary Role' : 'Select roles first'}</option>
                    {availableRoles.filter(r => editForm.roles?.includes(r.value)).map(role => (
                      <option key={role.value} value={role.value}>{role.label}</option>
                    ))}
                  </select>
                  <div className="mt-3 flex items-center space-x-2">
                    <input type="checkbox" id="isActiveToggle" checked={!!editForm.isActive} onChange={(e) => setEditForm(prev => ({ ...prev, isActive: e.target.checked }))} className="rounded border-gray-300 text-teal-600 focus:ring-teal-500" />
                    <label htmlFor="isActiveToggle" className="text-sm text-gray-700">Active</label>
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
                <p className="text-sm text-gray-700">UID: <span className="font-mono text-gray-900">{selectedUser.uid}</span></p>
                <p className="text-sm text-gray-700">Created: <span className="text-gray-900">{formatDate(selectedUser.createdAt)}</span></p>
              </div>
            </div>

            <div className="flex justify-end space-x-3 pt-6 border-t border-gray-200 mt-6">
              <button onClick={() => { setShowEditModal(false); setSelectedUser(null); }} className="inline-flex items-center px-4 py-2 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors">Close</button>
              <button onClick={saveEditUser} disabled={savingEdit} className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-teal-500 to-cyan-500 text-white font-medium rounded-lg hover:from-teal-600 hover:to-cyan-600 disabled:opacity-50 disabled:cursor-not-allowed transition-all">
                {savingEdit ? (<><Loader className="h-4 w-4 mr-2 animate-spin" />Saving...</>) : 'Save Changes'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserManagement;